import { Component, OnInit } from '@angular/core';
import { SelectItem,TreeNode } from 'primeng/api';
import { FormBuilder, FormGroup } from '@angular/forms';




@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FAQComponent implements OnInit {
    ngOnInit() {}

}


// WEBPACK FOOTER //
// ./src/app/faq/faq.component.ts